// extracted by mini-css-extract-plugin
module.exports = {"container":"RoundedCard_container__14ehY","border":"RoundedCard_border__1s2Qq"};